<template>
  <v-navigation-drawer
    :color="color"
    permanent
    :clipped="clipped"
    :fixed="fixed"
    :width="width"
    :app="app"
    :style="style"
  >
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "navigation-drawer",
    props: {
      app: Boolean,
      color: String,
      clipped: Boolean,
      fixed: Boolean,
      depth: {
        type: Number,
        default: 0,
      },
      width: {
        type: Number,
        default: 160,
      },
      referenceWidth: {
        type: Number,
        default: 160,
      },
    },
    computed: {
      style() {
        const top_padding = {};
        if (this.clipped) {
          top_padding.top = "48px";
        }

        const left_padding = {};
        if (this.depth > 0) {
          top_padding.left = `${this.depth * this.referenceWidth}px`;
        }

        return Object.assign({}, top_padding, left_padding);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
